module.exports = __webpack_public_path__ + "media/images/master_degree-96d94f1bd62df718640d1e9a69cde3f8.png";